module.exports = __webpack_public_path__ + "img/switch-vertical-01.3c48ae98.svg";